var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "headerTeacher" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 16, offset: 3 } }, [
            _c("div", { staticClass: "headerTeacher-title" }, [
              _c("div", { staticClass: "headerTeacher-title-left" }, [
                _vm._v("教师后台管理系统"),
              ]),
              _c("del"),
              _c("div", { staticClass: "headerTeacher-title-right" }, [
                _c("div", { staticStyle: { "font-weight": "700" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.personInfo.title))]),
                  _vm._v("老师，欢迎你！进入学习网 "),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }